var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "renderer" },
    [
      _vm.canRead
        ? _c(
            "router-link",
            { class: _vm.classNames, attrs: { to: _vm.link } },
            [_vm._v("\n    " + _vm._s(_vm.object.name) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.canRead
        ? _c("span", { class: _vm.classNames }, [
            _vm._v("\n    " + _vm._s(_vm.object.name) + "\n  "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }